<script type="text/javascript">
	import BaseModal from "./modal.svelte";
	import Icon from "../icon.svelte";
	import Loader from "../loader.svelte";
	import Bordered from "../borderedInput.svelte";
	let opened = true;


	let apiResponse, loading = false;
	export let payPrice = 15;

	export let payProvider;
	$: if(!opened && $$props.onClose) $$props.onClose(); 

	function apiRequest(){
		loading = true;
		window.api.pay(payPrice, payProvider, r=>{
			
			apiResponse = r;
			if (r.url) location.replace(r.url);
			else loading = false;
		})
	}
</script>

{#if opened}
<BaseModal bind:opened>
	<span slot="heading">
		Пополнить баланс
	</span>

	{#if apiResponse && apiResponse.status == "error"}
	<div class="message">
		<span>{apiResponse.message}</span>
	</div>
	{/if}

	<form action="#" on:submit|preventDefault={apiRequest}>
		<label for="pay">Сумма пополнения:</label>
		<Bordered>
			<input id="pay" type="number" min="1" step="1" class="app_input-transparent"
			bind:value={payPrice}> <i>&#x20bd;</i>
		</Bordered>

		<label>Выберите способ оплаты:</label>
		<div class="paySelect">
			<ul>
				<li>
					<input type="radio" bind:group={payProvider} id="payQiwi" value={'qiwi'}>
					<label for="payQiwi" class:selected={payProvider=='qiwi'}>
						<span>QIWI Кошелек</span>
						<span>Оплата через Qiwi</span>
					</label>
				</li>
				<li>
					<input type="radio" bind:group={payProvider} id="payCard" value={'card'}>
					<label for="payCard" class:selected={payProvider=='card'}>
						<span>Банковские карты РФ</span>
						<span>Visa, Mastercard, МИР (российских банков)</span>
					</label>
				</li>
				<li>
					<input type="radio" bind:group={payProvider} id="payEnot" value={'enot'}>
					<label for="payEnot" 
					class:selected={payProvider=='enot'}>
						<span>Enot.io</span>
						<span>ЮMoney, Банковские карты в RUB.</span>
					</label>
					
				</li>
			</ul>
			
		</div>

		<button class="app_button-primary" style="width:100%">
			{#if loading}<Loader/>{:else}Оплата ({payPrice} &#x20bd){/if}</button>
	</form>
</BaseModal>
{/if}

<style lang="scss">
@media(min-width: 1200px){
	.paySelect > ul{
		min-width: 402px;
	}
}
	.paySelect > ul{

		margin-left: -40px;
		list-style: none;
		li{
			input{display: none;}
			label{
				display: flex;
				flex-direction: column;
				padding: 15px 10px;
				cursor: pointer;
				border: 2px solid rgba(255, 255, 255, 0.1);
				border-radius: 7px;
				margin-bottom: 10px;
				opacity: .59;
				transition: .1s linear;

				&:hover{
					border: 2px solid #553781;
					background: #0F131C;
					opacity: .85;
				}
				&.selected{
					opacity: 1;
					border: 2px solid #553781;
					background: #0F131C;
				}
				span:first-child{
					font-weight: bold;
					font-size: 12pt !important;
				}
				span{
					font-weight: 400;
					font-size: 11pt;
				}
			}
		}
	}
	form > label{
		margin-bottom: 14px;
    display: block;
    margin-top: 16px;
	}
	form > button{
		margin-top: 15px;
	}
</style>